module.exports = __webpack_public_path__ + "static/media/allOurServices.2111bf48.png";